// @ts-nocheck
import { useLazyQuery }              from '@apollo/client'
import { ArrowUturnLeftIcon }        from '@heroicons/react/24/solid'
import FolderForm                    from './FolderForm'
import { Button }                    from '../../../components'
import { LoadingEllipsis }           from '../../../components/Loaders/Loaders'
import { GET_DOCUMENT_BY_ID }        from '../../../graphql/document'
import { useNavigate, useParams }    from 'react-router-dom'
import { useState, useLayoutEffect } from 'react'

export default function NewFolder() {
  const { unique_id }                         = useParams()
  const navigate: any                         = useNavigate()
  const [ parentDocument, setParentDocument ] = useState( null )

  const [ getParentDocument, { loading } ] = useLazyQuery( GET_DOCUMENT_BY_ID, {
    onCompleted: ( { documentByUid } ) => setParentDocument( documentByUid ),
    onError:     ( error: any ): void => console.log( error )
  } )

  useLayoutEffect( () => {
    if ( unique_id ) {
      getParentDocument( { variables: { input: { unique_id } } } )
    }
  }, [] )

  return (
    <div>
      { loading && <LoadingEllipsis klass="ellipse-yellow ellipse-xl p-4" /> }
      { !loading &&
        <>
          <div className="w-24 my-4">
            <Button
              label="Back"
              blue
              onClick={ (): any => navigate( -1 ) }
              icon={ <ArrowUturnLeftIcon className="w-4 h-4" /> }
            />
          </div>

          <h4 className="font-medium text-xl">
            New Folder
            { parentDocument && <span> in <em>{ parentDocument.title }</em></span> }
          </h4>

          <FolderForm parentId={ unique_id ?? null }></FolderForm>
        </>
      }
    </div>
  )
}
